<template lang="html">
    <v-card-title class="ModalHeader">
        <h1 class="ModalHeader-title">
            {{ title }}
        </h1>
        <v-btn
            v-if="isClosable"
            icon="mdi-close"
            :aria-label="$trans('button:close')"
            aria-hidden="false"
            size="x-large"
            variant="text"
            density="compact"
            @click="closeModal()"
        />
    </v-card-title>
</template>

<script setup>
import { createTranslatorWithDefaultNetworkWithI18nImported } from '@/translations/translations-utils'

defineProps({
    title: {
        type: String,
        default: ''
    },
    isClosable: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['closeModal'])

const translateForNetwork = createTranslatorWithDefaultNetworkWithI18nImported()
const $trans = (key) => translateForNetwork(key)

function closeModal () {
    emit('closeModal', false)
}
</script>

<style lang="scss">
@import '@/assets/scss/global';

.ModalHeader {
    display: flex!important;
    align-items: center!important;
    padding: $s4!important;

    &-title {
        @include handleOverflowTextContent;

        width: 100%;
        margin: 0;
        text-align: center;
        font-size: 24px;
    }
}
</style>
